import React, { useEffect } from "react";
import styles from "../assets/scss/pages.module.scss";
import Title from "components/title/Title";
import OpenCallsSection from "sections/guidePage/openCallsSection/OpenCallsSection";
import GrantsSection from "sections/guidePage/grantsSection/GrantsSection";
import RecommendationsSection from "sections/guidePage/recommendationsSection/RecommendationsSection";

const GuidePage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <div className={styles.guidePageContainer}>
      <div className="container">
        <Title text={"Guide for Artists"} bottomStrokeWidth={"59%"} />
      </div>
      <OpenCallsSection />
      <GrantsSection />
      <RecommendationsSection />
    </div>
  );
};

export default GuidePage;
